import React from "react";

const CatalogoPreparatoria = () => {
  return (
    <div
      style={{
        width: "100vw",
        minHeight: "100vh",
        backgroundColor: "#FFFFFF",
        fontFamily: "'Arial', sans-serif",
        padding: "0",
        margin: "0",
      }}
    >
      {/* Encabezado institucional */}
      <header
        style={{
          textAlign: "center",
          padding: "40px 20px 30px",
          backgroundColor: "#f5f9fb",
          borderBottom: "4px solid #355F73",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.05)",
        }}
      >
        <h1
          style={{
            fontFamily: "'Merriweather', serif",
            fontSize: "32px",
            color: "#355F73",
            margin: "0 0 10px",
            lineHeight: "1.2",
          }}
        >
          Preparatoria Tecnológica de Sistema Abierto <br />"Tomás G. Masaryk"
        </h1>
        <h2
          style={{
            fontFamily: "'Lato', sans-serif",
            fontSize: "20px",
            color: "#5A9CA7",
            margin: "0 0 20px",
            fontWeight: "normal",
          }}
        >
          Grupo Impulsor Educativo Tula de Allende
        </h2>
        <div style={{ marginTop: "10px" }}>
          <img
            src="/imagenes/Logoprepa.png"
            alt="Logo institucional"
            style={{
              width: "120px",
              height: "auto",
              filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))",
            }}
          />
        </div>
      </header>

      {/* Imágenes institucionales */}
      <section
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "20px",
          padding: "30px 10%",
        }}
      >
        <img
          src="/imagenes/prepa1.jpg"
          alt="Instalaciones de la preparatoria"
          style={{ width: "45%", borderRadius: "12px", boxShadow: "0px 0px 10px rgba(0,0,0,0.1)" }}
        />
        <img
          src="/imagenes/prepa4.jpg"
          alt="Alumnos en clase"
          style={{ width: "45%", borderRadius: "12px", boxShadow: "0px 0px 10px rgba(0,0,0,0.1)" }}
        />
      </section>

    {/* Modelo Educativo */}
<section
  style={{
    backgroundColor: "#355F73",
    color: "#ffffff",
    padding: "5px 12%", 
    fontFamily: "Arial, sans-serif",
  }}
>
  <h3 style={{ fontSize: "28px", marginBottom: "20px", fontWeight: "bold" }}>
    Modelo Educativo Flexible
  </h3>
  <p style={{ fontSize: "18px", marginBottom: "20px", lineHeight: "1.6" }}>
    La preparatoria permite iniciar, continuar o concluir estudios de nivel medio superior a través de un esquema modular que se adapta a las necesidades de cada estudiante.
  </p>
  <ul style={{ paddingLeft: "25px", listStyle: "disc", fontSize: "17px", lineHeight: "1.6" }}>
    <li>Programa enfocado en la formación integral del estudiante.</li>
    <li>Flexibilidad de horarios y avance modular.</li>
    <li>Material didáctico actualizado para un aprendizaje dinámico.</li>
    <li>Posibilidad de combinar estudios con actividades personales y laborales.</li>
  </ul>
</section>


{/* Información de Costos */}
<h3 style={{
  color: "#355F73",
  fontSize: "26px",
  margin: "50px 12% 20px",
  fontWeight: "bold",
  fontFamily: "Arial, sans-serif"
}}>
  Información Académica y de Costos
</h3>

{/* Plan de Estudios */}
<section
  style={{
    padding: "50px 12%",
    backgroundColor: "#EEF3FA",
    fontFamily: "Arial, sans-serif"
  }}
>
  <h3 style={{
    color: "#355F73",
    fontSize: "26px",
    marginBottom: "30px",
    fontWeight: "bold"
  }}>
    Plan de Estudios Modalidad Sistema Abierto
  </h3>
  <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
    <ul style={{ flex: 1, listStyleType: "disc", paddingLeft: "25px", fontSize: "16px", lineHeight: "1.6" }}>
      <li>MÓDULO 1: De la información al conocimiento</li>
      <li>MÓDULO 2: El lenguaje en la relación del hombre con el mundo</li>
      <li>MÓDULO 3: Representaciones simbólicas y algoritmos</li>
      <li>MÓDULO 4: Ser social y sociedad</li>
      <li>MÓDULO 5: Mi mundo en otra lengua</li>
      <li>MÓDULO 6: Tecnología de la información y comunicación</li>
      <li>MÓDULO 7: Textos y visiones del mundo</li>
      <li>MÓDULO 8: Matemáticas y representaciones del sistema natural</li>
      <li>MÓDULO 9: Universo natural</li>
      <li>MÓDULO 10: Sociedad mexicana contemporánea</li>
      <li>MÓDULO 11: Transformaciones en el mundo contemporáneo</li>
    </ul>
    <ul style={{ flex: 1, listStyleType: "disc", paddingLeft: "25px", fontSize: "16px", lineHeight: "1.6" }}>
      <li>MÓDULO 12: Mi vida en otra lengua</li>
      <li>MÓDULO 13: Argumentación</li>
      <li>MÓDULO 14: Variación en procesos sociales</li>
      <li>MÓDULO 15: Cálculo en fenómenos naturales y procesos sociales</li>
      <li>MÓDULO 16: Hacia un desarrollo sustentable</li>
      <li>MÓDULO 17: Evolución y sus repercusiones sociales</li>
      <li>MÓDULO 18: Estadística en fenómenos naturales y procesos sociales</li>
      <li>MÓDULO 19: Dinámica en la naturaleza: el movimiento</li>
      <li>MÓDULO 20: Optimización en sistemas naturales y sociales</li>
      <li>MÓDULO 21: Impacto de la ciencia y la tecnología</li>
      <li>MÓDULO 22: Informática</li>
    </ul>
  </div>
</section>

{/* Preparatoria Sistema Abierto */}
<section style={{ padding: "50px 12%", fontFamily: "Arial, sans-serif" }}>
  

  <table style={{
    width: "100%",
    borderCollapse: "collapse",
    textAlign: "center",
    fontSize: "16px"
  }}>
    <thead style={{ backgroundColor: "#355F73", color: "white" }}>
      <tr>
        <th style={{ padding: "12px", border: "1px solid #ccc" }}>Materias por quincena</th>
        <th style={{ padding: "12px", border: "1px solid #ccc" }}>Duración</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>1</td>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>13 meses</td>
      </tr>
      <tr>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>2</td>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>8 meses</td>
      </tr>
      <tr>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>3</td>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>7 meses</td>
      </tr>
      <tr>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>3 y 4</td>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>6 meses</td>
      </tr>
      <tr>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>4</td>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>Hasta en 5 meses</td>
      </tr>
    </tbody>
  </table>

  <p style={{ marginTop: "25px", fontSize: "16px", lineHeight: "1.6" }}>
    <strong>Inscripción (pago único):</strong> $1,300.00 <br />
    <strong>Colegiatura (semanal):</strong> $330.00 <br />
    <strong>Exámenes:</strong> $98.00 c/u <br />
    <strong>Certificado ante SEP:</strong> Sin costo
  </p>
  
</section>

<hr style={{
  width: "100%",
  border: "none",
  borderTop: "4px solid #355F73",
  margin: "60px 0"
}} />

{/* Plan Cuatrimestral por Asignaturas */}



{/* Plan Cuatrimestral por Asignaturas */}
<div style={{ marginTop: "40px", fontFamily: "Arial, sans-serif" }}>
  <h4 style={{
    color: "#355F73",
    fontSize: "24px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "30px"
  }}>
    Plan Cuatrimestral por Asignaturas Modalidad Semiescolarizada
  </h4>

  <div style={{
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "20px",
    justifyContent: "center"
  }}>
    {[
      { titulo: "CUATRIMESTRE I", materias: ["Matemáticas I", "Química I", "Ética y Valores I", "Introducción a las Ciencias Sociales", "Taller de Lectura y Redacción I", "Lengua Adicional al Español I", "Informática I", "Orientación Educativa"] },
      { titulo: "CUATRIMESTRE II", materias: ["Matemáticas II", "Química II", "Ética y Valores II", "Historia de México I", "Taller de Lectura y Redacción II", "Lengua Adicional al Español II", "Informática II", "Apreciación Artística"] },
      { titulo: "CUATRIMESTRE III", materias: ["Matemáticas III", "Biología I", "Física I", "Historia de México II", "Literatura I", "Lengua Adicional al Español III", "Principios de la Administración", "Fases del Proceso Administrativo"] },
      { titulo: "CUATRIMESTRE IV", materias: ["Matemáticas IV", "Biología II", "Física II", "Estructura Socioeconómica de México", "Literatura II", "Lengua Adicional al Español IV", "Producción Logística y Distribución", "Administración del Capital Humano"] },
      { titulo: "CUATRIMESTRE V", materias: ["Matemáticas IV", "Geografía", "Historia Universal Contemporánea", "Matemáticas Financieras I", "Economía I", "Derecho I", "Ciencias de la Comunicación I", "Administración Financiera", "Mercadotecnia"] },
      { titulo: "CUATRIMESTRE VI", materias: ["Filosofía", "Ecología y Medio Ambiente", "Metodología de la Investigación", "Matemáticas Financieras II", "Economía II", "Derecho II", "Ciencias de la Comunicación II", "Planificación y Gestión de Negocio", "Liderazgo"] }
    ].map((cuatri, index) => (
      <div key={index} style={{
        backgroundColor: "#f5f9fb",
        borderRadius: "12px",
        boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
        padding: "20px",
        borderTop: "4px solid #355F73"
      }}>
        <h3 style={{
          textAlign: "center",
          color: "#355F73",
          fontSize: "18px",
          marginBottom: "15px",
          fontWeight: "bold"
        }}>
          {cuatri.titulo}
        </h3>
        <ul style={{ paddingLeft: "20px", margin: 0 }}>
          {cuatri.materias.map((m, i) => (
            <li key={i} style={{ marginBottom: "6px", fontSize: "15px" }}>{m}</li>
          ))}
        </ul>
      </div>
    ))}
  </div>
</div>


{/* Preparatoria Semiescolarizada */}
<section style={{ padding: "50px 12%", fontFamily: "Arial, sans-serif" }}>
 

  <table style={{
    width: "100%",
    borderCollapse: "collapse",
    textAlign: "center",
    fontSize: "16px"
  }}>
    <thead style={{ backgroundColor: "#355F73", color: "white" }}>
      <tr>
        <th style={{ padding: "12px", border: "1px solid #ccc" }}>Duración</th>
        <th style={{ padding: "12px", border: "1px solid #ccc" }}>Colegiatura Semanal</th>
        <th style={{ padding: "12px", border: "1px solid #ccc" }}>Inscripción</th>
        <th style={{ padding: "12px", border: "1px solid #ccc" }}>Reinscripción</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>6 meses</td>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>$400.00</td>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>$1,000.00</td>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>$1,000.00 c/ 2 meses</td>
      </tr>
      <tr>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>8 meses</td>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>$350.00</td>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>$1,000.00</td>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>$1,000.00 c/ 2 meses</td>
      </tr>
      <tr>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>1 año y medio</td>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>$330.00</td>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>$1,000.00</td>
        <td style={{ padding: "12px", border: "1px solid #ccc" }}>$1,000.00 c/ 4 meses</td>
      </tr>
    </tbody>
  </table>

  <p style={{ marginTop: "25px", fontSize: "16px", lineHeight: "1.6" }}>
    <strong>Exámenes:</strong> $10.00 | <strong>Extraordinarios:</strong> $80.00 por materia<br />
    <strong>Documentación final:</strong> Certificado $3,500.00 | Fotos $200.00<br />
    <em>Documentos ante SEP del Estado de Morelos, entrega aproximada en 2 meses.</em>
  </p>
</section>


        
     

      {/* Imágenes adicionales */}
      <section
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "20px",
          padding: "30px 10%",
        }}
      >
        <img
          src="/imagenes/prepa2.jpg"
          alt="Alumnos en talleres prácticos"
          style={{ width: "45%", borderRadius: "12px", boxShadow: "0px 0px 10px rgba(0,0,0,0.1)" }}
        />
        <img
          src="/imagenes/prepa3.jpg"
          alt="Evento académico"
          style={{ width: "45%", borderRadius: "12px", boxShadow: "0px 0px 10px rgba(0,0,0,0.1)" }}
        />
      </section>
    </div>
  );
};

export default CatalogoPreparatoria;